module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n    此藥物總存量: " + _vm._s(_vm.selectedDrugTotalAmount) + " \n  ")]), _vm._v(" "), (_vm.currentProgress === 'confirmAmount') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.currentDrugInDevice.stock,
      "autoCaculateAmount": false,
      "compType": 'Confirm',
      "valueMoreThanZero": false,
      "defaultPackCount": _vm.currentDrugInDevice.pack_count,
      "deviceId": _vm.currentDrugInDevice.device.id,
      "checkNum": _vm.currentDrugInDevice.max_stock
    },
    on: {
      "confirmAmountFinish": _vm.confirmAmountFinish
    }
  }, [_c('h5', [_vm._v("確認藥盒內數量")])]) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'action') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.currentDrugInDevice.stock,
      "deviceId": _vm.currentDrugInDevice.device.id,
      "defaultPackCount": _vm.currentDrugInDevice.pack_count,
      "valueMoreThanZero": false,
      "inputReadOnly": true
    },
    on: {
      "setActionData": _vm.getActionData
    }
  }, [_c('h5', [_vm._v("藥物移除數量")])]) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'setMinStock') ? _c('NumberSet', {
    attrs: {
      "defaultAmount": _vm.minStorage,
      "canBeZero": true,
      "inputLabel": '更新安全存量'
    },
    on: {
      "setNum": _vm.getMinStorage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c273677","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RemoveOutdatedDrugFlow/ConfirmFlow.vue
// module id = 1380
// module chunks = 1